@if (tileViewService.tileViewServiceError$ | async; as error) {
  <rotec-service-error-v2> </rotec-service-error-v2>
} @else {
  <div class="filter">
    <div class="fast-filter">
      @if (searchText) {
        <rotec-chip-v2
          [darkBlue]="true"
          icon="close"
          class="filter-chip"
          [iconPlacement]="'right'"
          (chipRemove)="clearSearch()"
        >
          {{ searchText }}
        </rotec-chip-v2>
      }
      <rotec-select-v2
        [items]="state.plants"
        [secondary]="true"
        [selectedItem]="state.selectedPlant"
        placeholder="Plants"
        (selectedItemChange)="filterForPlant($event)"
        id="plants"
      ></rotec-select-v2>
      <rotec-select-v2
        [items]="state.groups"
        [secondary]="true"
        [selectedItem]="state.selectedGroup"
        placeholder="Groups"
        (selectedItemChange)="filterForGroup($event)"
        id="groups"
      ></rotec-select-v2>
      <rotec-text-input-v2
        placeholder="Search"
        icon="search"
        (confirmValueChange)="search($event)"
      ></rotec-text-input-v2>
    </div>
  </div>
  <rotec-spinner key="overview" [fixed]="false"></rotec-spinner>
  <div class="main">
    @if (state.tiles?.length) {
      <div class="grid">
        @for (tile of state.tiles; track tile) {
          <div class="grid-item">
            @if (tile._assetType === 'machine') {
              <ma-machine-tile class="tile" [machine]="tile"></ma-machine-tile>
            } @else {
              <ma-tooling-tile class="tile" [tooling]="tile"></ma-tooling-tile>
            }
          </div>
        }
      </div>
    }
    @if (
      !state.tiles?.length &&
      (state.tileViewState.selectedPlant || state.tileViewState.selectedGroup)
    ) {
      <div>
        <div class="message no-matches" translate>
          There are no entries for the selected filters. Remove or change filters to find assets.
        </div>
      </div>
    }
    @if (
      !state.tiles?.length &&
      !state.tileViewState.filter &&
      !state.tileViewState.selectedPlant &&
      !state.tileViewState.selectedGroup &&
      !(loading$ | async)
    ) {
      <div class="tiles">
        <rotec-action-tile-v2 (click)="createMachineTask()">{{
          'New Machine Task' | translate
        }}</rotec-action-tile-v2>
        <rotec-action-tile-v2 (click)="createToolingTask()">{{
          'New Tooling Task' | translate
        }}</rotec-action-tile-v2>
      </div>
    }
  </div>
}
